export default __webpack_public_path__ + "static/media/garden.006f96a0.webp";